import React from 'react'
import cx from 'classnames'
import url from 'front-end-core/core/url'
import { SEARCH } from 'constants/controllers'
import { DEFAULT_FLAVOUR, FLAVOUR_TITLES } from 'constants/flavours'
import { DynamicFlavourTabLabel, LinkWrapper } from 'components/tiled-menu/FlavourTabs'
import { useSelector } from 'react-redux'
import selectPageParameters from 'redux/selectors/selectPageParameters'
import { get } from 'libraries/lodash'

export const Tab = ({ flavour, isActive, href, title, isAnnotationPage = false }) => {
  const linkClassNames = cx(
    'pa4 pa3-t pa2-m transition-all db no-underline bg-qa-tab relative outline-0',
    {
      'selected white default-cursor': isActive,
      [flavour]: true,
      'cadet-blue': !isActive
    }
  )

  return (
    <LinkWrapper {...{ flavour, title, isAnnotationPage }}>
      <a className={linkClassNames} {...{ href }}>
        <DynamicFlavourTabLabel {...{ flavour, active: isActive, title, isAnnotationPage }} />
      </a>
    </LinkWrapper>
  )
}

export const QAHeader = ({ aol, flavour = DEFAULT_FLAVOUR, searchType, searchPhrase }) => {
  const pageParameters = useSelector(selectPageParameters)

  const tabs = get(pageParameters, 'qa.flavours', []).map(flavourTab => ({
    title: FLAVOUR_TITLES[flavourTab],
    href: flavour === flavourTab ? null : url(SEARCH, { aol, flavour: flavourTab, searchType }, { q: searchPhrase }),
    isActive: flavour === flavourTab,
    flavour: flavourTab
  }))

  return (
    <div>
      <div className='layout-width-constraint'>
        <nav className='pt5 pb2'>
          <div className='flex justify-center pt6 pb3 flavour-tabs relative'>
            <ul className='flex list-reset pa0 ma0 w-80' data-help-item='flavours' data-help-position='bottom'>
              {tabs.map(tab => (
                <Tab key={tab.flavour} {...tab} />
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  )
}
